<template>
    <v-card class="mt-3">
        <v-toolbar color="primary" density="compact">
            <v-toolbar-title>{{ title || $t("company.cardDocsTitle") }}</v-toolbar-title>
            <v-toolbar-items>
                <v-btn
                    v-if="canEdit"
                    size="large"
                    elevation="0"
                    @click="openFileDialog"
                    :disabled="documents.length >= maxDocuments"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-row class="gap-2">
                <v-col v-for="(doc, index) in documents" :key="doc.id" cols="auto">
                <ReservationDocumentCard
                    :title="`${$t('company.document')} ${index + 1}`"
                    :subtitle="getFileName(doc.url)"
                    :subtitle-tooltip="getFileName(doc.url)"
                    color="success"
                    :clickable="false"
                    class="d-inline-block"
                >
                    <template #actions>
                        <v-tooltip location="top">
                            <template #activator="{ props }">
                                <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="openDoc(doc.url)">
                                    mdi-eye-outline
                                </v-icon>
                            </template>
                            {{ $t('reservations.view') }}
                        </v-tooltip>
                        <v-tooltip v-if="canEdit" location="top">
                            <template #activator="{ props }">
                                <v-icon size="small" class="cursor-pointer" v-bind="props" @click.stop="deleteDocument(doc.id)">
                                    mdi-delete-outline
                                </v-icon>
                            </template>
                            {{ $t('common.delete') }}
                        </v-tooltip>
                    </template>
                </ReservationDocumentCard>
                </v-col>
            </v-row>
        </v-card-text>

        <v-file-input
            ref="fileInput"
            v-model="newFiles"
            multiple
            style="display: none"
            accept="application/pdf"
            @change="uploadFiles"
        />
    </v-card>
</template>

<script>
import ReservationDocumentCard from "@/components/reservation/ReservationDocumentCard.vue";
import axios from "axios";
import { showAlertModal } from "@/utils";

export default {
    name: "DocumentManager",
    components: { ReservationDocumentCard },
    props: {
        documents: Array,
        uploadUrl: String,
        deleteUrlPrefix: String,
        title: {
            type: String,
            default: "",
        },
        maxDocuments: {
            type: Number,
            default: 10,
        },
        onUpload: Function,
        onDelete: Function,
        canEdit: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            newFiles: [],
        };
    },
    methods: {
        showAlertModal,
        getFileName(url) {
            return url ? url.split("/").pop() : "";
        },
        openDoc(url) {
            if (url) window.open(url, "_blank", "noopener,noreferrer");
        },
        openFileDialog() {
            this.$refs.fileInput.click();
        },
        async uploadFiles() {
            if (!this.newFiles.length) return;
            const formData = new FormData();
            this.newFiles.forEach((file) => formData.append("documents", file));

            try {
                await axios.post(this.uploadUrl, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                this.onUpload?.();
            } catch (error) {
                console.error("Upload error:", error);
                this.showAlertModal(
                    this.$store,
                    this.$t("company.uploadFailed"),
                    "danger",
                    12000,
                    error
                );
            } finally {
                this.newFiles = [];
            }
        },
        async deleteDocument(docId) {
            if (!confirm(this.$t("company.confirmDeleteDocument"))) return;

            try {
                await axios.delete(`${this.deleteUrlPrefix}/${docId}/`);
                this.onDelete?.();
            } catch (error) {
                console.error("Delete error:", error);
                this.showAlertModal(
                    this.$store,
                    this.$t("company.deleteFailed"),
                    "danger",
                    12000,
                    error
                );
            }
        },
    },
};
</script>
